var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2",
    "data-name": "Group 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 33.458,
    height: 33.458,
    viewBox: "0 0 33.458 33.458",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 33.458,
    height: 33.458,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M30.552,24.681A15.279,15.279,0,1,1,14.817,8.943a.455.455,0,0,1,.465.452c.028,3.043.267,14.82.267,14.82H30.093a.457.457,0,0,1,.459.466",
    transform: "translate(0 -6.036)",
    fill: "#9ca1b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M57.836.647h0Zm0,1.43a13.337,13.337,0,0,1,11.24,11.242c-3.594.013-8.548.052-11.275.075.01-2.789.029-7.836.035-11.317M56.536,0a.648.648,0,0,0-.649.646c0,3.988-.033,11.921-.042,14.132a.575.575,0,0,0,.577.579h.006c2.168-.019,9.84-.084,14.081-.091a.647.647,0,0,0,.644-.678A15.28,15.28,0,0,0,56.565,0h-.029",
    transform: "translate(-37.693)",
    fill: "#9ca1b2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPie);
export default __webpack_public_path__ + "static/media/pie.db243ac2245ba94675a941cf20fcbdf6.svg";
export { ForwardRef as ReactComponent };